import { Navigate, createBrowserRouter } from 'react-router';
import { AuthGuard } from './components/AuthGuard';
import { AdminLayout } from './layouts/AdminLayout';
import { LoginPage } from './pages/LoginPage';
import { ReviewQueuePage } from './pages/ReviewQueuePage';
import { OrgDetailPage } from './pages/OrgDetailPage';
import { MonthlyCloseReviewPage } from './pages/MonthlyCloseReviewPage';
import { MetricsPage } from './pages/MetricsPage';
import { LazyOrgChatPage } from './pages/chat/LazyOrgChatPage';

export const router = createBrowserRouter([
  // Public
  { path: '/login', element: <LoginPage /> },

  // Protected
  {
    element: <AuthGuard />,
    children: [
      {
        path: '/',
        element: <AdminLayout />,
        children: [
          { index: true, element: <ReviewQueuePage /> },
          { path: 'metrics', element: <MetricsPage /> },
          { path: 'clients', element: <Navigate to="/" replace /> },
          { path: 'orgs/:orgId', element: <OrgDetailPage /> },
          { path: 'orgs/:orgId/close/:closeId', element: <MonthlyCloseReviewPage /> },
          { path: 'orgs/:orgId/chat', element: <LazyOrgChatPage /> },
          { path: 'orgs/:orgId/chat/:conversationId', element: <LazyOrgChatPage /> },
          // Catch-all: unknown in-app paths redirect to the queue rather than
          // React Router's raw dev error boundary.
          { path: '*', element: <Navigate to="/" replace /> },
        ],
      },
    ],
  },
]);
